// src/pages/Cancel.jsx
import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/theme.css";
import "../styles/cosmic.css";
import "../styles/Cancel.css";

export default function Cancel() {
	const navigate = useNavigate();

	useEffect(() => {
		// Redirect immediately to dashboard (no query param needed - user knows they cancelled)
		navigate('/dashboard', { replace: true });
	}, [navigate]);

	// Fallback UI (shouldn't be seen due to instant redirect)
	return (
		<main className="cosmic-bg">
			<div className="container center-card card">
				<h1>Payment canceled</h1>
				<p>No worries—your card was not charged. You can try again anytime.</p>
				<Link className="btn btn--ghost" to="/subscribe">
					Back to plans
				</Link>
			</div>
		</main>
	);
}
